// LOAD-BEARING: never programmatically focus the name/city fields when this
// returns true. iOS Safari only raises the soft keyboard on a focus caused
// directly by a real tap, so an effect-driven `.focus()` leaves a blinking
// caret and no keyboard. Full rationale: README.md ("iOS soft-keyboard fix").
export function isCoarsePointerDevice(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  // hover:none + pointer:coarse selects touchscreens without catching a
  // trackpad or a touch-capable desktop that also has a mouse.
  return window.matchMedia('(hover: none) and (pointer: coarse)').matches;
}
